import { render, staticRenderFns } from "./NamingTableInput.vue?vue&type=template&id=21b4563d"
import script from "./NamingTableInput.vue?vue&type=script&lang=js"
export * from "./NamingTableInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21b4563d')) {
      api.createRecord('21b4563d', component.options)
    } else {
      api.reload('21b4563d', component.options)
    }
    module.hot.accept("./NamingTableInput.vue?vue&type=template&id=21b4563d", function () {
      api.rerender('21b4563d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/LayoutSettingsModal/NamingTableInput.vue"
export default component.exports